// extracted by mini-css-extract-plugin
export default {"container":"FloatingCarts_container__owSbo","button":"FloatingCarts_button__ZXvtR","badge":"FloatingCarts_badge__EBA7E"};